class MasonryReview extends HTMLElement {
  constructor() {
    super();

    this.container = this.closest(".masonry-reviews__wrapper");
    this.info = this.querySelector(".masonry-review__info");
    this.readMore = this.querySelector(".masonry-review__read-more");
    this.readMore.addEventListener("click", this.toggle.bind(this));

    if (this.info.clientHeight < this.info.scrollHeight)
      this.classList.add("overflowing");

    this.classList.add("loaded");
  }

  toggle() {
    const expandedCard = this.container.querySelector(".expanded");
    if (expandedCard && expandedCard !== this) expandedCard.toggle();

    const isExpanded = this.classList.toggle("expanded");

    if (isExpanded) this.readMore.innerHTML = "Read less";
    else this.readMore.innerHTML = "Read more";
  }
}

if (!customElements.get("masonry-review"))
  customElements.define("masonry-review", MasonryReview);
